import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { workspaceStorage } from '../services/knowledgeApi'
import { createWorkspace } from '../types'

export const useWorkspaceStore = defineStore('knowledgeWorkspace', () => {
  const workspaces = ref([])
  const currentWorkspaceId = ref(null)
  const isLoading = ref(false)

  const currentWorkspace = computed(() =>
    workspaces.value.find(w => w.workspace_id === currentWorkspaceId.value) || null
  )

  async function fetchWorkspaces() {
    isLoading.value = true
    try {
      workspaces.value = await workspaceStorage.getAll()
    } finally {
      isLoading.value = false
    }
  }

  async function addWorkspace(name) {
    const ws = createWorkspace(name)
    await workspaceStorage.create(ws)
    workspaces.value.push(ws)
    return ws
  }

  async function updateWorkspace(workspaceId, updates) {
    const updated = await workspaceStorage.update(workspaceId, updates)
    const index = workspaces.value.findIndex(w => w.workspace_id === workspaceId)
    if (index !== -1) workspaces.value[index] = updated
    return updated
  }

  async function removeWorkspace(workspaceId) {
    await workspaceStorage.remove(workspaceId)
    workspaces.value = workspaces.value.filter(w => w.workspace_id !== workspaceId)
    if (currentWorkspaceId.value === workspaceId) {
      currentWorkspaceId.value = workspaces.value[0]?.workspace_id || null
    }
  }

  function switchWorkspace(workspaceId) {
    currentWorkspaceId.value = workspaceId
  }

  return {
    workspaces,
    currentWorkspaceId,
    currentWorkspace,
    isLoading,
    fetchWorkspaces,
    addWorkspace,
    updateWorkspace,
    removeWorkspace,
    switchWorkspace
  }
})
